import { createSlice, createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

const initialState: any = {
  exmenuRequisition: [],
  ishybrid: false,
  deliverydate: {},
  revenuePerDayValue: {},
   revenueInfo: {
    revenuePerDay: null,   
  },
  loading: false,
  error: null,
  saveLoading: false,
};

export const getExMenuRequisition = createAsyncThunk(
  'ExceptionalMenuRequisition/GetExceptionalMenuRequisitionDetails',
  async (payload: any) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/ExceptionalMenuRequisition/GetExceptionalMenuRequisitionDetails`, payload);
    return response?.data?.data;
  }
);


export const AddExMenuRequisitionRow = createAsyncThunk(
  'ExceptionalMenuRequisition/AddRowsExceptionalMenuRequisition',
  async (payload: any) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/ExceptionalMenuRequisition/AddRowsExceptionalMenuRequisition`, payload);
    return response?.data?.data;
  }
);

export const SaveExMenuRequisitionRow = createAsyncThunk(
  'ExceptionalMenuRequisition/UpsertExceptionalMenuRequisition',
  async (payload: any) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/ExceptionalMenuRequisition/UpsertExceptionalMenuRequisition`, payload);
    return response?.data?.data;
  }
);
export const fetchEMRRevenueInfo = createAsyncThunk(
  'ExceptionalMenuRequisition/GetEMRRevenuePerDayValue',
  async (payload: object) => {    
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/ExceptionalMenuRequisition/GetEMRRevenuePerDayValue`, payload);
    return response?.data?.data;
  }
);

export const resetExMenuRequisition = createAction('ExceptionalMenuRequisition/resetData');


const exmenuRequisitionSlice = createSlice({
  name: 'exmenuRequisition',
  initialState,
   reducers: {
     updateRevenuePerDay: (state, action) => {
       state.revenueInfo.revenuePerDay = action.payload;
     },
     resetState: () => initialState, // Reset state to initial values
    },
  extraReducers: (builder) => {
    builder
      .addCase(getExMenuRequisition.pending, (state) => {
        state.loading = true;
      })
      .addCase(getExMenuRequisition.fulfilled, (state, action) => {
        state.loading = false;
        state.exmenuRequisition = action.payload;
        state.ishybrid = action.payload?.ishybrid ?? false;
      })
      .addCase(getExMenuRequisition.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(AddExMenuRequisitionRow.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddExMenuRequisitionRow.fulfilled, (state, action) => {
        state.loading = false;
        state.exmenuRequisition = action.payload;
      })
      .addCase(AddExMenuRequisitionRow.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(SaveExMenuRequisitionRow.pending, (state) => {
        state.saveLoading = true;
      })
      .addCase(SaveExMenuRequisitionRow.fulfilled, (state, action) => {
        state.saveLoading = false;
        state.exmenuRequisition = action.payload;
      })
      .addCase(SaveExMenuRequisitionRow.rejected, (state, action) => {
        state.saveLoading = false;
        state.error = action.error.message;
      })
      // Reset data when filter changes
      .addCase(resetExMenuRequisition, (state) => {
        state.exmenuRequisition = null;
      });

       builder
            .addCase(fetchEMRRevenueInfo.fulfilled, (state, action) => {
              // state.loading = false;
              state.revenueInfo.revenuePerDay = action.payload.revenueperday;
              state.revenueInfo.theoPerDay = action.payload.theocost;
            })
            .addCase(fetchEMRRevenueInfo.rejected, (state, action) => {
              // state.loading = false;
              state.error = action.error.message;
            });
  },
});
export const { updateRevenuePerDay, resetState } = exmenuRequisitionSlice.actions;
export default exmenuRequisitionSlice.reducer;
